import React, { useState } from 'react';
import './index.less';

import bqBg from '../../../assets/image/home/bq_bg.png';
import jrBg from '../../../assets/image/home/jr_bg.png';
import rbBg from '../../../assets/image/home/rb_bg.png';
import tjBg from '../../../assets/image/home/tj_bg.png';
import rwaBg from '../../../assets/image/home/rwa_bg.png';
import dppBg from '../../../assets/image/home/dpp_bg.png';

import { Link } from 'react-router-dom';
import ServiceModal from '@/components/ServiceModal';
import RcQueueAnim from 'rc-queue-anim';
import { OverPack } from 'rc-scroll-anim';

const panelsData = [
  {
    id: 1,
    title: 'DF 数据金融',
    desc: '以大数据与区块链为双重驱动引擎，打破数据孤岛, 释放数据价值为200余家银行机构提供服务，累计交易量20000亿。',
    backgroundImage: jrBg,
    gradient: '180deg, rgba(48,76,149,0.15) 0%, #304C95 98%',
    advantage: [
      { text: '跨行流水验证', style: { gridColumn: 'span 2' } },
      { text: '贷后资金监管', style: { gridColumn: 'span 2' } },
      { text: '保险重复理赔', style: { gridColumn: 'span 2' } },
    ],
    link: '/industryApplications/jinzong'
  },
  {
    id: 2,
    title: 'DA 数据资产',
    desc: '客户实现数据资产全链服务，实现数据的标准化和资产化管理，极大提升数据资产化的效率与透明度。',
    backgroundImage: rbBg,
    gradient: '180deg, rgba(0,131,255,0.25) 0%, #004CFF 100%',
    advantage: ['数据合规服务', '数据估值服务', '数据入表服务', '渠道赋能', { text: '数据资产运营服务', style: { gridColumn: 'span 2' } }],
    link: '/industryApplications/dataAssets'
  },
  {
    id: 3,
    title: 'SLC 数字司法',
    desc: '帮助实现侵权行为实时监控、规模化、低成本治理，为权利方提供从监测到诉讼维权再到民事/刑事打击的全流程解决方案。',
    backgroundImage: bqBg,
    gradient: '180deg, rgba(39,162,254,0.25) 0%, #00A4FE 100%',
    advantage: ['全网实时监测', '取证快速便捷', '司法有效性', '区块链存证'],
    link: '/industryApplications/digitalJustice'
  },
  {
    id: 4,
    title: 'ADR 商事调解',
    desc: '商事调解ADR是通过非诉纠纷化解机制委托第三方进行协商的商事调解服务，重点面向金融行业批量标准化个贷业务。',
    backgroundImage: tjBg,
    gradient: '180deg, rgba(205,205,251,0.1) 0%, #4C54D5 100%',
    advantage: ['专业区块链', '海量案例', '多司法端', '丰富的工具'],
    link: '/industryApplications/mediation'
  },
  {
    id: 5,
    title: 'DPP 数字护照',
    desc: '为产品赋予数字身份，提供全面的追踪与认证服务，助力企业和消费者共推绿色消费，实现可持续发展。',
    backgroundImage: rwaBg,
    gradient: '180deg, rgba(154,249,255,0.25) 0%, #42D6E5 100%',
    advantage: ['供应链透明', '效率提升', '质量控制', '智能决策', '绿色发展', '品牌信任'],
    link: '/industryApplications/digitalPassport'
  },
  {
    id: 6,
    title: 'RWA 智能资产',
    desc: '将现实世界的资产转化为可交易的智能资产，提高资产流动性、降低投资门槛，打破传统金融体系的壁垒，让资产管理更加便捷、高效。',
    backgroundImage: dppBg,
    gradient: '180deg, rgba(255,255,255,0.1) 0%, #3259CE 100%',
    advantage: ['大规模', '可持续收益', '资产可信', '全球化服务'],
    link: '/industryApplications/digitalAssets'
  }
];

export default function Top2() {
  const [activePanel, setActivePanel] = useState(1);

  const handlePanelClick = (id) => {
    setActivePanel(id);
  };

  return (
    <OverPack playScale={0.15} always={false}>
      <div className='home-solution'>
        <div className='title'>
          <p>行业应用</p>
          <span>可信数据空间为基础的开放式应用生态，赋能多类型场景，聚集多种类分布式应用</span>
          <span>深度服务多领域新质生产力发展</span>
        </div>
        <RcQueueAnim type={'scale'}>
          <div key={1} className="solution-box">
            {panelsData.map((panel) => (
              <div
                key={panel.id}
                className={`panel ${activePanel === panel.id ? 'expand' : 'collapse'}`}
                style={{ background: `linear-gradient(${activePanel === panel.id ? '318deg, rgba(236,240,250,0) 0%, #ECF0FA 100%' : panel.gradient}), url('${panel.backgroundImage}') top right / cover no-repeat` }}
                onClick={() => handlePanelClick(panel.id)}
              >
                <h2 className='solution-title'>{panel.title}</h2>
                <div className='solution-desc'>{panel.desc}</div>
                <div className='solution-advantage'>
                  {
                    panel.advantage.map((d, index) => 
                      <div className='solution-advantage-item' style={d.style || {}} key={index}>
                        <img src={require('../../../assets/image/home/correct.png')}/>
                        { d.text || d }
                      </div>
                    )
                  }
                </div>
                <div className='solution-btn-box'>
                  <Link to={panel.link}>
                    <div className='commom-btn-blue'>了解详情</div>
                  </Link>
                  <ServiceModal>
                    <div className='commom-btn-white'>免费咨询</div>
                  </ServiceModal>
                </div>
              </div>
            ))}
          </div>
        </RcQueueAnim>
      </div>
    </OverPack>
  );
}
